import { OutcomeOddsUpdateState } from 'features/coupon/interface';
import {
	AvatarInterface,
	CollapsedMarketsType,
	MedalInterface,
	PlayerMedalsInterface,
	StatisticInterface,
} from 'features/customerPanel/cpPlayerProfile/interface/interface';
import { CpPanel } from 'features/customerPanel/interface/cpPanel.interface';
import { DictionariesState, NAMESPACE as DICTIONARIES_NAMESPACE } from 'features/dictionaries/store/interface';
import { LiveDetailsState } from 'features/eventLive/interface/interface';
import { EventAllDetailsDataState } from 'features/eventPreMatch/interface/sportPrematch';
import { HomeState } from 'features/Home';
import { LiveReduceState } from 'features/live/interface/live';
import { LoginState } from 'features/login/interface/login';
import { OffersState } from 'features/offers/interface/store.interface';
import { PromotionTitle } from 'features/promotion/store/promotionDetails.action';
import { RegisterModalState } from 'features/registration/interface/registration';
import { SportGlobelState } from 'features/sports/interface/interface';
import { AppTheme, PLACEMENT_SCREENS } from 'shared/constants/common';
import { BeforeInstallPromptEvent } from '../global';
import { CategoryDataInterface } from './sb-betting-common.interface';

export * from './sb-betting-common.interface';
export * from './sports-type';

export type LoadingStateStatus = 'LOADING' | 'SUCCESS' | 'FAIL';

export interface LoadingState {
	api: Record<string, LoadingStateStatus>;
}

export interface Action<T = string, P = any> {
	type: T;
	payload: P;
}

export interface State {
	home: HomeState;
	loading: LoadingState;
	login: LoginState;
	navigation: NavigationTypeState;
	coupon: CouponState;
	layout: LayoutState;
	balanceData: BalanceState;
	live: LiveReduceState;
	sport: SportGlobelState;
	placements: PlacementStateInterface;
	cpPanel: CpPanel;
	offers: OffersState;
	[DICTIONARIES_NAMESPACE]: DictionariesState;
	categories: CategoriesStateInterface;
	cookie: CookieState;
	registerModal: RegisterModalState;
	eventPreMatchData: EventAllDetailsDataState;
	eventLiveData: LiveDetailsState;
	promotionDetails: PromotionTitle;
	inGameCouponCount: InGameCouponCountInterface;
	playerProfile: AvatarState;
	bottomDrawer: BottomDrawer;
	modal: ModalState;
	modalDeposit: ModalState;
	couponOverviewPanel: couponOverviewPanelState;
	common: CommonState;
}

interface couponOverviewPanelState {
	isPrimaryPanelOverviewPanel: boolean;
}

export interface CommonState {
	pwaReference: BeforeInstallPromptEvent | null;
}

export interface ModalState {
	isModalOpen: boolean;
	children: null;
	settings?: {
		modalClass?: string;
		onClose?: () => void;
	};
}
export interface BottomDrawer {
	isDrawerOpen: boolean;
}

interface AvatarState {
	avatar: AvatarInterface[];
	playerStats: StatisticInterface[];
	medals: MedalInterface[];
	collectedMedals: PlayerMedalsInterface;
	lastDepositMethod: string | null;
	lastDepositBankId: number | null;
	collapsedMarkets: CollapsedMarketsType;
}

export interface unreadMessageState {
	lastMessageTitle: string;
	messageCount: number;
	lastMessageDate: string;
	lastMessageId: number;
}
export interface CookieState {
	notShowCookie: any;
}

export interface BalanceState {
	selectedBalanceType: string;
	mainBalance: number | null;
	bonusBalance: number | null;
	bonusBalanceList: any;
	depositCounter: number | null;
	depositInfo?: any;
}

export interface NavigationTypeState {
	appTheme: AppTheme;
	unreadMessages: unreadMessageState;
	breadcrumbs: any[];
	isEventPopup?: boolean;
	onClickArrow?: () => void;
}

// using PlaceBet interface for also outcomes in BETSType.
export interface PlaceBet {
	eventName: string;
	outcomeOdds: number;
	outcomeId: string;
	sportId: string | number;
	eventId: number;
	eventType: any;
	banker?: boolean;
	outcomeLive?: boolean;
	outcomeName?: string;
	gameName?: string;
	gameType?: string | number;
	categoryId?: string | number;
	league: string;
	gameId: number;
	selectedBet: boolean;
	isLive: boolean;
	isCompleted?: boolean;
	showWarning?: boolean;
	outcomeUpdateState?: OutcomeOddsUpdateState;
	isBetBuilder?: boolean;
	betBuilderOddsArray?: any[];
	combinationType?: number;
	isFinished?: boolean;
}

export interface Analytics {
	removedBets: number;
	replacedBets: number;
	enabledBets: number;
	disabledBets: number;
}

export interface CouponState {
	bets: any;
	betStatics: any;
	awaitingWinningResp: boolean;
	analytics: Analytics;
}

export interface LayoutState {
	liveEvents: any[];
	count: number;
	isLiveChatVisible: string;
}

export interface OutcomesAndBlocks {
	outcomes: PlaceBet[];
	blocks: PlaceBet[][];
}

export interface BETSType extends OutcomesAndBlocks {
	stake: number;
	betType: number;
	addAccumulator: boolean;
	acceptHigherOdds: boolean;
	acceptAnyOdds: boolean;
	currencyCode: string;
	bonusBet: boolean;
	betMode: string;
	wagerBonusId?: number;
	freeBetStack?: number | null;
	isFreeBetSelected: boolean;
	freebetId?: number | null;
}

export interface ResponseObj<T> {
	isError: boolean;
	message: string;
	errorMessages: { [key: string]: string[] };
	data: T;
}

export interface Pagination {
	page: number;
	recordPerPage: number;
	total: number;
}

export interface PlacementStateInterface {
	[PLACEMENT_SCREENS.HOME]: any[];
	[PLACEMENT_SCREENS.LIVE]: any[];
	[PLACEMENT_SCREENS.SPORT]: any[];
}

export interface NavLinkInterface {
	name: string;
	icon: React.ReactElement;
	link: string;
	animatedIconLink?: string;
	onClick?: () => void;
}
export interface CategoriesStateInterface {
	all: CategoryDataInterface[];
	popular: CategoryDataInterface[];
	filtered: CategoryDataInterface[];
}

export interface InGameCouponCountInterface {
	inGameCouponCount: number;
}

export enum EventType {
	PREMATCH = 1,
	LIVE = 2,
	OUTRIGHT = 3,
	VIRTUAL_FOOTBALL = 20,
	VIRTUAL_HORSE_RACING = 8,
	VIRTUAL_DOG_RACING = 13,
	VIRTUAL_BASKETBALL = 17,
}

export interface TimeInterface {
	hours: string;
	minutes: string;
	seconds: string;
}
